import { API } from 'app/api';
import { getUserInfo } from 'app/modules/User';

export default function fetchTelescopeStatus(obsId) {
  const { at, cid, token} = getUserInfo();
  // return API.get(`/api/obs/getObservatoryStatus?obsId=${obsId}`);
  return API.post(`/api/obs/getObservatoryStatus`, {at, cid, token, obsId});
}
